import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-noentry',
  templateUrl: './noentry.component.html',
  styleUrls: ['./noentry.component.scss']
})
export class NoentryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/noentry/noentry.component.ts